export default __webpack_public_path__ + "static/media/tick.e7d01aef.svg";